










import { IVendorCoverage } from '@/api/types-vendor'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'VendorInspectionTypes'
})
export default class extends Vue {
  @Prop({ default: false }) isEdit!: boolean
  @Prop({ type: Object }) value!: IVendorCoverage
  inspType1 = true
  inspType2 = true
  inspType3 = true

  handleChange() {
    this.$nextTick(() => {
      console.log(
        `handleChange ${this.value.inspType1} ${this.inspType2}, ${this.inspType3}`
      )
      this.value.inspType1 = this.inspType1
      this.value.inspType2 = this.inspType2
      this.value.inspType3 = this.inspType3
    })
  }
}
